import { Badge } from '@/shared/components/ui/badge';

/** [앱] 배지 — 회색 버튼 안에서는 흰 배경(onWhite), 그 외에는 회색 배경 */
export const AppBadge = ({
  onWhite = false,
  label = '앱',
}: {
  onWhite?: boolean;
  label?: string;
}) => <Badge tone={onWhite ? 'onWhite' : 'app'}>{label}</Badge>;
